import {
  HMRC_URL_AUTH,
  HMRC_URL_AUTH_SUCCESS,
  HMRC_URL_AUTH_FAILURE,
  HMRC_GENERATE_ACCESS_TOKEN,
  HMRC_GENERATE_ACCESS_TOKEN_SUCCESS,
  HMRC_GENERATE_ACCESS_TOKEN_FAILURE,
} from "./actionType";

const initialState = {
  urlAuthData: [],
  urlAuthDataLoading: false,
  urlAuthDataError: null,

  accessTokenData: [],
  accessTokenDataLoading: false,
  accessTokenDataError: null,
};

const hmrcReducer = (state = initialState, action) => {
  switch (action.type) {
    case HMRC_URL_AUTH:
      return {
        ...state,
        urlAuthDataLoading: true,
        urlAuthDataError: null,
      };
    case HMRC_URL_AUTH_SUCCESS:
      return {
        ...state,
        urlAuthData: action.payload,
        urlAuthDataLoading: false,
      };
    case HMRC_URL_AUTH_FAILURE:
      return {
        ...state,
        urlAuthDataLoading: false,
        urlAuthDataError: action.payload,
      };
    case HMRC_GENERATE_ACCESS_TOKEN:
      return {
        ...state,
        accessTokenDataLoading: true,
        accessTokenDataError: null,
      };
    case HMRC_GENERATE_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        accessTokenData: action.payload,
        accessTokenDataLoading: false,
      };
    case HMRC_GENERATE_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        accessTokenDataLoading: false,
        accessTokenDataError: action.payload,
      };
    default:
      return state;
  }
};

export default hmrcReducer;
